var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAdoptersinline = function SvgAdoptersinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFBF00",
    d: "M0 12.145 5.98 22.5h12.002L24 12.145 17.982 1.5H5.98z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M17.357 10.141 14.12 9.69l-1.445-2.816a.77.77 0 0 0-.286-.273.8.8 0 0 0-.778 0 .77.77 0 0 0-.286.273L9.88 9.69l-3.237.451a.77.77 0 0 0-.376.162.7.7 0 0 0-.23.328.7.7 0 0 0-.015.395c.033.13.104.25.204.344l2.342 2.192-.552 3.096a.7.7 0 0 0 .044.393c.053.125.14.233.254.312a.77.77 0 0 0 .79.054L12 15.955l2.895 1.46a.78.78 0 0 0 .79-.054.73.73 0 0 0 .254-.311.7.7 0 0 0 .044-.393l-.552-3.096 2.343-2.191c.1-.094.17-.213.204-.343a.7.7 0 0 0-.015-.395.7.7 0 0 0-.23-.328.76.76 0 0 0-.374-.162z"
  })));
};
export default SvgAdoptersinline;